//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  convertToMoney,
  convertToPercent,
  convertToNumberFormat,
} from '../../../../../../../common/functions/numeric';

export default {
  name: 'MetasCrescimento',
  props: {
    pendencia: null,
    isActivatorInput: true,
  },
  data: () => ({
    menu: false,
    item: 'attach_money',
    items: ['attach_money'],
  }),
  methods: {
    headers() {
      return [
        { text: this.$t('label.meta_de'), value: 'meta_de', sortable: false, align: 'center' },
        { text: this.$t('label.meta_ate'), value: 'meta_ate', sortable: false, align: 'center' },
        { text: this.$t('label.bonificacao_pagamento'), value: 'bonificacao_pagamento', sortable: false, align: 'center' },
      ];
    },
    exibirMeta(valor) {
      if (this.pendencia.ehValor) {
        return convertToMoney(valor);
      }
      return convertToNumberFormat(valor);
    },
    exibirPagamento(valor) {
      if (this.pendencia.ehPercentual) {
        return convertToPercent(valor);
      }
      return convertToMoney(valor);
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/MetasCrescimento.vue?vue&type=script&lang=js&